import { Component, OnInit, Input } from '@angular/core';
import { WMAIApiService , Experience } from '../../core';
import { WgisService } from '../../wgis/wgis.service';

@Component({
  selector: 'app-esperienza-admin-preview',
  templateUrl: './esperienza-admin-preview.component.html',
})
export class EsperienzaAdminPreviewComponent implements OnInit {

  @Input() esperienza: Experience;
  imageUrl = "";
  
  constructor(
    private wmaiservice: WMAIApiService,
    private wgisservice: WgisService,
  ) { 
    this.imageUrl = "./assets/img/sentieri_default.jpg";
  }

  ngOnInit(){
    window.scrollTo(0, 0)
  }

}
